import { atom } from 'jotai';
import { BottomToolbarRes } from '@/types/api/hall/bottom-toolbar.d';

export const bottomToolbarAtom = atom<BottomToolbarRes['list']>([]);